import { Header } from "../components/promill/Header";
import { Footer } from "../components/promill/Footer";
import { Link } from "react-router-dom";
import { MapPin, Clock, Bell, ArrowRight } from "lucide-react";

const StoresPage = () => (
    <div data-testid="stores-page" className="bg-pm-cream min-h-screen">
        <Header />
        <section className="relative py-20 md:py-28 overflow-hidden">
            <div aria-hidden className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-pm-yellow/25 blur-3xl" />
            <div aria-hidden className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-pm-greenBright/20 blur-3xl" />
            <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-pm-black text-pm-yellow border-2 border-pm-black text-xs font-bold tracking-[0.25em] uppercase mb-6">
                    <span className="w-2 h-2 rounded-full bg-pm-yellow animate-pulse" />
                    Coming Soon
                </div>
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-[-0.02em] text-pm-black leading-[1.05]">
                    ProMill stores are<br />
                    <span className="text-pm-green">on their way.</span>
                </h1>
                <p className="mt-6 text-base md:text-lg text-pm-black/70 max-w-xl mx-auto leading-relaxed">
                    Our first ProMill experience centers are launching soon. We're crafting spaces that
                    match the food — clean, warm, and made for the way modern India eats. Stay tuned!
                </p>

                <div className="mt-10 grid sm:grid-cols-3 gap-4 max-w-xl mx-auto">
                    {[
                        { icon: MapPin, label: "Multi-city launch" },
                        { icon: Clock, label: "Opening 2026" },
                        { icon: Bell, label: "Priority updates" },
                    ].map((it, i) => (
                        <div key={i} data-testid={`coming-item-${i}`} className="bg-white rounded-2xl p-5 border border-pm-black/8 flex flex-col items-center text-center">
                            <div className="h-11 w-11 rounded-full bg-pm-yellow/20 flex items-center justify-center mb-3">
                                <it.icon className="w-5 h-5 text-pm-green" />
                            </div>
                            <span className="text-sm font-bold text-pm-black">{it.label}</span>
                        </div>
                    ))}
                </div>

                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <Link to="/contact" data-testid="stores-waitlist-cta" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-pm-yellow text-pm-black font-bold hover:bg-pm-yellowBright transition-colors">
                        Join Waitlist
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                    <Link to="/menu" data-testid="stores-menu-cta" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-pm-black/15 font-bold hover:bg-white transition-colors">
                        Explore Menu
                    </Link>
                </div>
            </div>
        </section>
        <Footer />
    </div>
);

export default StoresPage;
